<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view/>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  // components: {
  //   HelloWorld
  // }
  data () {
    return{
      
    }
  },
  created () {
    // input获取焦点的时候禁止视图滚动
    var wv=window.plus.webview.currentWebview();
    wv.setStyle({'softinputMode':'adjustResize'});
  },
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
